// import Enumerable from "linq";
// import { IAccessPermission } from "../../common/models/AccessPermission";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IGroupSecurityModel } from "../../common/models/IGroupSecurityModel";
import { IObjectSecurityModel } from "../../common/models/IObjectSecurityModel";
import { IDRCXAvailableObjectsDTO } from "../../common/models/drcx/DRCXAvailableObjectsDTO";
import { GetAvailableObjectOptions } from "../drcx-configuration-data-service/Models";
import GroupDataService from "../group-data-service/GroupDataService";
import restService from "../rest-service/RestService";
import { ISecurityPermissionsAvailableObject } from "./Models";
import { IAccessFunctionalityData } from "../../common/models/IAccessFunctionalityData";
import Enumerable from "linq";

const AccessControlService = {

    getAccessFunctionalityData: async function (
        groupID: number,
        signal?: AbortSignal
    ): Promise<IAccessFunctionalityData> {
        const path = `/groups/${groupID}/accessFunctionalityData`;

        const response = await restService.get<IAccessFunctionalityData>(path, signal);

        return response.data;
    },

    // private _accessFunctionalityPromise: Services.RestPromise<void>;
    // private _functionalityTypesCache: Array<Models.IKeyValuePair<number, string>>;
    // private _accessTypesCache: Array<Models.IKeyValuePair<number, string>>;
    // private _accessFunctionalityMasksCache: linqjs.IDictionary<Enums.eLynxObjectTypeEnum, linqjs.IDictionary<Enums.AccessFunctionalityTypeEnum, number>>;
    // private _accessFunctionalityHashesCache: linqjs.IDictionary<Enums.eLynxObjectTypeEnum, Models.IAccessFunctionalityHashes>;

    // public hasPermission(contextGroupID: number, objectType: Enums.eLynxObjectTypeEnum, objectID: number, functionalityType: Enums.AccessFunctionalityTypeEnum, access: Enums.AccessTypeEnum): Services.RestPromise<boolean> {
    //     var path: string = [
    //         "groups",
    //         contextGroupID,
    //         objectType.toString(),
    //         objectID,
    //         "accesscontrol",
    //         "functionality",
    //         functionalityType.toString(),
    //         "access",
    //         access.toString()
    //     ].join("/");
    //     return this._restService.get<boolean>(path)
    //         .then((data) => { return data.entity; });
    // }

    // public getAccessFunctionalityTypesForObject(groupID: number, objectType?: Enums.eLynxObjectTypeEnum, functionalityType?: Enums.AccessFunctionalityTypeEnum, accessType?: Enums.AccessTypeEnum): Services.RestPromise<Array<Models.IObjectTypeAccessFunctionalityModel>> {
    //     var path: string = "accessfunctionalitytypes";

    //     var queryParams: Models.IAccessControlQueryParameters = <Models.IAccessControlQueryParameters>{
    //         contextGroupID: groupID,
    //         objectType: objectType,
    //         functionalityType: functionalityType,
    //         accessType: accessType
    //     };

    //     return this._restService.get<Array<Models.IObjectTypeAccessFunctionalityModel>, Models.IAccessControlQueryParameters>(path, queryParams).then((data) => {
    //         return data.entity;
    //     });
    // }

    grantPermissions: async function (
        contextGroupID: number,
        securityItems: Array<IObjectSecurityModel | IGroupSecurityModel>,
        applyToChildren: boolean,
        signal?: AbortSignal
    ): Promise<void> {

        var path: string = [
            "permissions",
            "grant"
        ].join("/");

        var params = {
            contextGroupID: contextGroupID,
            applyToChildren: applyToChildren
        };

        if (Enumerable.from(securityItems).any(o => o.targetObject.objectType === eLynxObjectTypeEnum.Group)) {
            await restService.post<Array<IObjectSecurityModel | IGroupSecurityModel>, void, { contextGroupID: number, applyToChildren: boolean; }>(
                path,
                securityItems,
                signal,
                undefined,
                params
            );
        } else {
            await restService.post<Array<IObjectSecurityModel | IGroupSecurityModel>, void, { contextGroupID: number, applyToChildren: boolean; }>(
                path,
                securityItems,
                signal,
                undefined,
                params
            );
        }
    },

    revokePermissions: async function (
        contextGroupID: number,
        securityItems: Array<IObjectSecurityModel | IGroupSecurityModel>,
        signal?: AbortSignal
    ): Promise<void> {

        var path: string = [
            "permissions",
            "revoke"
        ].join("/");

        var params = {
            contextGroupID: contextGroupID,
        };

        if (Enumerable.from(securityItems).any(o => o.targetObject.objectType === eLynxObjectTypeEnum.Group)) {
            await restService.delete<Array<IObjectSecurityModel | IGroupSecurityModel>, { contextGroupID: number; }>(
                path,
                signal,
                params,
                securityItems,
            );
        } else {
            await restService.delete<Array<IObjectSecurityModel | IGroupSecurityModel>, { contextGroupID: number; }>(
                path,
                signal,
                params,
                securityItems
            );
        }
    },

    // public getObjectSecurityDetails(contextGroupID: number, objectType: Enums.eLynxObjectTypeEnum, objectID: number): Services.RestPromise<Array<Models.IObjectSecurityDataModel>> {
    //     var path: string = [
    //         "permissions",
    //         Enums.eLynxObjectTypeEnum[objectType],
    //         objectID,
    //         "Roles"
    //     ].join("/");

    //     var params: Models.IRestQueryParams = <Models.IRestQueryParams>{ contextGroupID: contextGroupID };

    //     return this._restService.get<Array<Models.IObjectSecurityDataModel>, Models.IRestQueryParams>(path, params).then((data) => {
    //         return data.entity;
    //     });
    // }

    getObjectUserRoleAccess: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number,
        signal?: AbortSignal
    ): Promise<Array<IGroupSecurityModel>> {
        const path: string = `permissions/${eLynxObjectTypeEnum[objectType]}/${objectID}/access`;
        const params = { contextGroupID: groupID };

        const response = await restService.get<Array<IGroupSecurityModel>, { contextGroupID: number; }>(path, signal, params);

        return response.data;
    },

    getObjectUserRoleAccessToObjects: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        signal?: AbortSignal
    ): Promise<Array<IObjectSecurityModel>> {
        const path = `groups/${groupID}/${objectType === eLynxObjectTypeEnum.Device ? "devices" : "wells"}/access`;

        const response = await restService.get<Array<IObjectSecurityModel>>(path, signal);

        return response.data;
    },

    getAvailableObjects: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        signal?: AbortSignal
    ): Promise<Array<ISecurityPermissionsAvailableObject>> {

        if (objectType === eLynxObjectTypeEnum.Tag) {
            const tats = await GroupDataService.getTagAssociationTypesInUse(groupID, signal);

            return tats.map(tat => {
                return {
                    id: tat.objectID,
                    objectType: eLynxObjectTypeEnum.Tag,
                    displayText: tat.name
                };
            });

        } else {
            const path: string = `groups/${groupID}/drcxconfig/availableObjects`;

            const response = await restService.get<IDRCXAvailableObjectsDTO, GetAvailableObjectOptions>(
                path,
                signal,
                {
                    includeDevices: objectType === eLynxObjectTypeEnum.Device,
                    includeTanks: objectType === eLynxObjectTypeEnum.Tank,
                    includeWells: objectType === eLynxObjectTypeEnum.Well,
                    includeTankBatteries: objectType === eLynxObjectTypeEnum.TankBattery,
                    includeDescendentGroups: false
                });

            const objects = objectType === eLynxObjectTypeEnum.Well
                ? response.data.wells
                : objectType === eLynxObjectTypeEnum.Device
                    ? response.data.devices
                    : objectType === eLynxObjectTypeEnum.TankBattery
                        ? response.data.tankBatteries
                        : objectType === eLynxObjectTypeEnum.Tank
                            ? response.data.tanks
                            : [];

            return objects.map(obj => {
                return {
                    id: obj.id,
                    objectType: objectType,
                    displayText: obj.dt
                };
            });
        }
    }

    // // TODO: These don't have localization
    // public getAccessTypes(groupID: number): When.Promise<Array<Models.IKeyValuePair<number, string>>> {

    //     if (!this._accessFunctionalityPromise) {
    //         this._initAccessFunctionalityCaches(groupID);
    //     }

    //     return when(this._accessFunctionalityPromise).then(() => {
    //         return this._accessTypesCache;
    //     });
    // }

    // public getFunctionalityTypes(groupID: number): When.Promise<Array<Models.IKeyValuePair<number, string>>> {

    //     if (!this._accessFunctionalityPromise) {
    //         this._initAccessFunctionalityCaches(groupID);
    //     }

    //     return when(this._accessFunctionalityPromise).then(() => {
    //         return this._functionalityTypesCache;
    //     });
    // }

    // public getAccessFunctionalityMasks(groupID: number): When.Promise<linqjs.IDictionary<Enums.eLynxObjectTypeEnum, linqjs.IDictionary<Enums.AccessFunctionalityTypeEnum, number>>> {

    //     if (!this._accessFunctionalityPromise) {
    //         this._initAccessFunctionalityCaches(groupID);
    //     }

    //     return when(this._accessFunctionalityPromise).then(() => {
    //         return this._accessFunctionalityMasksCache;
    //     });
    // }

    // public getAccessFunctionalityHashes(groupID: number): When.Promise<linqjs.IDictionary<Enums.eLynxObjectTypeEnum, Models.IAccessFunctionalityHashes>> {

    //     if (!this._accessFunctionalityPromise) {
    //         this._initAccessFunctionalityCaches(groupID);
    //     }

    //     return when(this._accessFunctionalityPromise).then(() => {
    //         return this._accessFunctionalityHashesCache;
    //     });
    // }

    // private _initAccessFunctionalityCaches(groupID: number) {

    //     const path: string = [
    //         "groups",
    //         groupID,
    //         "accessFunctionalityCacheData"
    //     ].join("/");

    //     // Retrieve reference data
    //     this._accessFunctionalityPromise = this._restService
    //         .get<IAccessFunctionalityCacheData>(path)
    //         .then(data => {

    //             const afts: Array<IAccessFunctionalityType> = data.entity.accessFunctionalityTypes;

    //             var access: { objectType: number;accessPermissions: Models.IAccessPermission[] }[] = Enumerable
    //                 .from(afts)
    //                 .groupBy(
    //                     aft => aft.objectType,
    //                     aft => aft,
    //                     (key, group) => {
    //                         return {
    //                             objectType: key,
    //                             accessPermissions: group
    //                                 .groupBy(
    //                                     aft => aft.functionalityType,
    //                                     aft => aft,
    //                                     (key, group) =>
    //                                     <Models.IAccessPermission>{
    //                                         functionalityType: key,
    //                                         access: 0xFFFF & group.sum(aft => aft.accessType)
    //                                     }
    //                                 ).toArray()
    //                         };
    //                     }
    //                 )
    //                 .toArray();

    //             this._accessFunctionalityMasksCache = Enumerable
    //                 .from(access)
    //                 .toDictionary(
    //                     element => element.objectType,
    //                     element => Enumerable
    //                     .from(element.accessPermissions)
    //                     .toDictionary(
    //                         element => element.functionalityType,
    //                         element => element.access
    //                     )
    //                 );

    //             this._accessFunctionalityHashesCache = Enumerable
    //                 .from(access)
    //                 .toDictionary(
    //                     element => element.objectType,
    //                     element => {
    //                         return <Models.IAccessFunctionalityHashes>{
    //                             view: this.getPermissionHash(
    //                                 Enumerable
    //                                 .from(element.accessPermissions)
    //                                 .where(element => (element.access & Enums.AccessTypeEnum.Read_View) == Enums.AccessTypeEnum.Read_View)
    //                                 .distinct(element => element.functionalityType)
    //                                 .select(ft => <Models.IAccessPermission>{
    //                                     functionalityType: ft.functionalityType,
    //                                     access: Enums.AccessTypeEnum.Read_View
    //                                 })
    //                                 .toArray()),
    //                             admin: this.getPermissionHash(
    //                                 Enumerable
    //                                 .from(element.accessPermissions)
    //                                 .select(ft => <Models.IAccessPermission>{
    //                                     functionalityType: ft.functionalityType,
    //                                     access: ft.access
    //                                 })
    //                                 .toArray())
    //                         };
    //                     }
    //                 );

    //             this._functionalityTypesCache = Enumerable
    //                 .from(data.entity.functionalityTypes)
    //                 .select(ft => <Models.IKeyValuePair<number, string>>{
    //                     key: ft.id,
    //                     value: ft.name
    //                 })
    //                 .toArray();

    //             this._accessTypesCache = Enumerable
    //                 .from(data.entity.accessTypes)
    //                 .select(ft => <Models.IKeyValuePair<number, string>>{
    //                     key: ft.id,
    //                     value: ft.name
    //                 })
    //                 .toArray();
    //         });
    // }

    // getPermissionHash: (permissions: Array<IAccessPermission>): string => {
    //     //reorder permissions
    //     let orderedPermissions: Array<IAccessPermission> =
    //         Enumerable.from(permissions)
    //             .select(o => <IAccessPermission>{
    //                 functionalityType: o.functionalityType,
    //                 access: o.access
    //             })
    //             .orderBy(o => o.functionalityType)
    //             .toArray();

    //     //convert all access types to unsigned, for consistancy in permissionHashs (so accessType -1 = 65535), using (x & 0xffff)
    //     Enumerable.from(orderedPermissions).select(o => {
    //         o.access &= 0xFFFF;
    //     }).toArray();

    //     //stringify permissions
    //     var permissionString: string = JSON.stringify(orderedPermissions);

    //     //return hash
    //     return CryptoJS.SHA1(permissionString).toString();
    // }
};

export default AccessControlService;